import type { CommandAction } from '../../CommandPalette'
import { getSectionRequiredCapabilities } from '@emporion/config/sections'
import type { BuildCommandActionsContext } from './types'
import { canAccessSection } from '../../../utils/permissions'

const PROFILE_ACTION_SECTION_KEYS: Record<string, string> = {
  'profile-contact': 'profile-contact',
  'profile-addresses': 'profile-addresses',
  'profile-smtp': 'profile-smtp',
  'profile-security': 'profile-security',
  'profile-sessions': 'profile-sessions',
  'profile-team': 'profile-team',
  'profile-danger': 'profile-danger',
}

export const buildProfileCommandActions = (
  { t, setSection, userCapabilities }: BuildCommandActionsContext,
  options?: { isCustomerOnly?: boolean },
): CommandAction[] => {
  const actions: CommandAction[] = [
    {
      id: 'profile-contact',
      name: t('command.profile.contact'),
      shortcut: ['meta', 'p'],
      keywords: 'profilo contatto email telefono',
      group: t('command.group.profile'),
      subtitle: t('command.profile.contact.subtitle'),
      perform: () => setSection('profile-contact'),
    },
    {
      id: 'profile-addresses',
      name: t('command.profile.preferences'),
      keywords: 'profilo preferenze lingua comunicazioni',
      group: t('command.group.profile'),
      subtitle: t('command.profile.preferences.subtitle'),
      perform: () => setSection('profile-addresses'),
    },
    {
      id: 'profile-smtp',
      name: t('command.profile.smtp'),
      keywords: 'profilo smtp email runtime',
      group: t('command.group.profile'),
      subtitle: t('command.profile.smtp.subtitle'),
      perform: () => setSection('profile-smtp'),
    },
    {
      id: 'profile-security',
      name: t('command.profile.security'),
      keywords: 'profilo sicurezza password',
      group: t('command.group.profile'),
      subtitle: t('command.profile.security.subtitle'),
      perform: () => setSection('profile-security'),
    },
    {
      id: 'profile-sessions',
      name: t('command.profile.sessions'),
      keywords: 'profilo sessioni dispositivi login',
      group: t('command.group.profile'),
      subtitle: t('command.profile.sessions.subtitle'),
      perform: () => setSection('profile-sessions'),
    },
    {
      id: 'profile-team',
      name: t('command.profile.team'),
      keywords: 'profilo team ruoli permessi',
      group: t('command.group.profile'),
      subtitle: t('command.profile.team.subtitle'),
      perform: () => setSection('profile-team'),
    },
    {
      id: 'profile-danger',
      name: t('command.profile.danger'),
      keywords: 'profilo privacy consensi gdpr',
      group: t('command.group.profile'),
      subtitle: t('command.profile.danger.subtitle'),
      perform: () => setSection('profile-danger'),
    },
  ]

  if (options?.isCustomerOnly !== true) {
    return actions.filter((action) => {
      const sectionKey = PROFILE_ACTION_SECTION_KEYS[action.id]

      if (!sectionKey) return true
      return canAccessSection(sectionKey, userCapabilities, (key: string) => getSectionRequiredCapabilities(key))
    })
  }

  const allowed = new Set(['profile-contact', 'profile-addresses', 'profile-security'])
  return actions.filter((action) => allowed.has(action.id))
}
